import { render, staticRenderFns } from "./UpdateModal.vue?vue&type=template&id=33ceb2b4&"
import script from "./UpdateModal.vue?vue&type=script&lang=js&"
export * from "./UpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33ceb2b4')) {
      api.createRecord('33ceb2b4', component.options)
    } else {
      api.reload('33ceb2b4', component.options)
    }
    module.hot.accept("./UpdateModal.vue?vue&type=template&id=33ceb2b4&", function () {
      api.rerender('33ceb2b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Accomodation/UpdateModal.vue"
export default component.exports